var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklistAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.095,
    height: 16.504,
    viewBox: "0 0 19.095 16.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "alert-triangle-fill",
    d: "M20.233,15.418,13.572,4.371a2.979,2.979,0,0,0-5.02,0L1.89,15.418a2.606,2.606,0,0,0-.043,2.606A2.927,2.927,0,0,0,4.4,19.5H17.723a2.927,2.927,0,0,0,2.553-1.442,2.606,2.606,0,0,0-.043-2.64Zm-9.171.608a.869.869,0,1,1,.869-.869A.869.869,0,0,1,11.062,16.026Zm.869-3.474a.869.869,0,0,1-1.737,0V9.078a.869.869,0,1,1,1.737,0Z",
    transform: "translate(-1.519 -2.996)",
    fill: "#e25131"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistAlert);
export default __webpack_public_path__ + "static/media/ChecklistAlert.68ce156c1f2471b362458f20514dc4ce.svg";
export { ForwardRef as ReactComponent };